import Vue from 'vue'

const menu = [
  {
    icon: 'fal fa-fw fa-shopping-basket',
    text: 'Cart',
    to: { name: 'Cart' },
    showItemCount: true
  },
  {
    icon: 'fal fa-fw fa-cash-register',
    text: Vue.i18n.translate('Sales'),
    to: { name: 'ReceiptsIndex' }
  },
  {
    icon: 'fal fa-fw fa-inventory',
    text: Vue.i18n.translate('Products'),
    to: { name: 'ProductsIndex' }
  },
  {
    icon: 'fal fa-fw fa-wallet',
    text: Vue.i18n.translate('Cash Management'),
    to: { 'name': 'CashRegistersCashManagement' }
  },
  {
    icon: 'fal fa-fw fa-warehouse-alt',
    text: Vue.i18n.translate('Inventory Counts'),
    to: { name: 'InventoryCountsIndex' }
  },
  {
    icon: 'fal fa-fw fa-users',
    text: Vue.i18n.translate('Customers'),
    to: { name: 'CustomersIndex' }
  },
  {
    icon: 'fal fa-fw fa-shelves',
    text: Vue.i18n.translate('VapeVault'),
    to: { name: 'VapeVault' }
  },
  {
    icon: 'fal fa-fw fa-cog',
    text: Vue.i18n.translate('Settings'),
    to: { name: 'CashRegistersSettings' }
  }
]

export default menu



// WEBPACK FOOTER //
// ./src/utils/menu-sidebar.js